/**
 * Bottom sheets for preferences flow (menu, fund list, learn more).
 *
 * Belongs here: sheet UI.
 * Does not belong here: navigation impl.
 */
import type { ReactNode } from 'react'
import BottomSheetContent from '../../../../../../components/BottomSheetComponents/BottomSheetContent'
import type { PreferenceFundItem } from '../../setup/types'
import type { PortfolioFundLabel } from '../../setup/config'
import { FundLabelWithSeparator } from '../header/FundLabelWithSeparator'
import { FundListItem } from '../header/FundListItem'

export interface PreferenceTypeFundListSheetProps {
  categoryIcon: ReactNode
  categoryTitle: string
  fundLabel: PortfolioFundLabel
  fundList: PreferenceFundItem[]
  onDismiss: () => void
}

export function PreferenceTypeFundListSheet({
  categoryIcon,
  categoryTitle,
  fundLabel,
  fundList,
  onDismiss
}: PreferenceTypeFundListSheetProps) {
  return (
    <BottomSheetContent
      onDismiss={onDismiss}
      headingComponent={
        <div className="px-5">
          <span className="flex h-8 w-8 shrink-0 items-center justify-center text-[#232323]" aria-hidden> {categoryIcon}</span>
          <div className="flex items-center gap-3 pt-3">
            <div className="min-w-0 flex-1">
              <h2 className="text-[22px] font-[500] text-[#232323]">{categoryTitle}</h2>
              <p className="text-[14px] font-[400] text-[#6A6E6E] mt-0.5 flex flex-wrap items-center">
                <FundLabelWithSeparator label={fundLabel} />
              </p>
            </div>
          </div>
        </div>
      }
      bottomSheetHeadingClassName="!mb-0"
      bottomSheetBodyClassName="flex flex-col gap-2 overflow-y-auto no-scrollbar max-h-[60vh] px-0"
      bottomSheetCtas={<></>}
    >
      <div className="flex flex-col pt-3">
        {fundList.map((fund) => (
          <div
            key={fund.isin}
            className="rounded-lg bg-white py-4"
          >
            <FundListItem fund={fund} />
          </div>
        ))}
      </div>
    </BottomSheetContent>
  )
}
